export function queryHelper (url, params) {
  const parts = Object.keys(params)
    .filter(key => params[key] !== undefined && params[key] !== null)
    .map(key => `${key}=${params[key]}`)
  return parts.length ? `${url}?${parts.join('&')}` : url
}



// WEBPACK FOOTER //
// ./src/_helpers/query-helper.js